module.exports = __webpack_public_path__ + "media/images/brands/marque-inoa-02722a73f2fabab6bbbeef6effd0071f.jpg";